/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { Page } from 'features/ui/types'
import * as liveReportServiceAPI from 'liveReportService'
import * as API from '../../api'

export const retrieveEmojis = createAsyncThunk(
  'emoji/retrieveEmojis',
  async (_, { getState, rejectWithValue }) => {
    // handle dynamic API
    const {
      ui: { page }
    } = getState() as { ui: { page: string } }
    const dynamicAPI = page === Page.LiveReport ? liveReportServiceAPI : API

    try {
      const response = await dynamicAPI.retrieveEmojis()
      return response.data
    } catch (err) {
      return rejectWithValue((err as API.FetchError)?.response?.data)
    }
  }
)
